import e from "react";
import { getIconColor as l } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const d = {
  display: "block"
}, p = ({ size: a = 16, useVw: c, useRem: i, color: t, withColor: n, removeClassName: r, disableSSR: f, style: o, ...F }) => {
  const m = o ? { ...d, ...o } : d;
  return /* @__PURE__ */ e.createElement(h, { disableSSR: f }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "fulizhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 14 14", width: c ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (i ? "rem" : "px"), height: c ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (i ? "rem" : "px"), className: r ? "" : "iconpark-icon", style: m, fill: "none", ...F }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: n ? l(t, 0, "#FAFAFA") : "#FAFAFA",
      d: "M7.38 4.51c-.228.165-.54.16-.81.113-.32-.057-.682-.193-1.032-.358-.694-.327-1.402-.8-1.706-1.103A1.66 1.66 0 0 1 3.826.815 1.66 1.66 0 0 1 6.174.82c.303.304.776 1.012 1.103 1.707.055.117.107.236.154.354l.028-.063c.262-.59.65-1.191.91-1.45.565-.565 1.49-.521 2.064.053.574.575.619 1.5.053 2.065-.259.259-.86.648-1.45.91a3.54 3.54 0 0 1-.888.28c-.257.037-.559.027-.769-.166ZM5.82 1.174c.248.248.691.9 1.005 1.566.156.33.271.648.317.906a1.264 1.264 0 0 1 .02.272c-.008.095-.034.147-.06.173-.043.044-.167.089-.444.04-.258-.046-.576-.162-.907-.318-.665-.313-1.318-.756-1.566-1.005a1.16 1.16 0 0 1-.005-1.64 1.16 1.16 0 0 1 1.64.006Zm1.841 2.762c0 .12.03.179.054.203.034.034.132.075.362.042.214-.03.479-.12.756-.242.56-.249 1.1-.607 1.3-.806.35-.35.347-.958-.054-1.358-.4-.4-1.007-.403-1.357-.053-.2.199-.558.74-.806 1.299a3.058 3.058 0 0 0-.243.757 1.225 1.225 0 0 0-.012.158Z",
      clipRule: "evenodd",
      fillRule: "evenodd"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: n ? l(t, 1, "#FFD21F") : "#FFD21F",
      d: "M1.5 6.5A.5.5 0 0 1 1 6V4.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5H12v6a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-6h-.5Z"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: n ? l(t, 2, "#fff") : "#fff",
      d: "M5.5 6.5H5V4h4v2.5h-.5V13h-3V6.5Z"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: n ? l(t, 3, "#262933") : "#262933",
      d: "M3 6.5h9V7H3z"
    }
  )));
}, E = p;
export {
  E as default
};
